import React, { useCallback } from 'react';
import Table from '../common/Table/Table';
import EditButton from '../common/ActionButton/EditButton';
import DeleteButton from '../common/ActionButton/DeleteButton';
import CopyButton from '../common/ActionButton/CopyButton';
import DownloadButton from '../common/ActionButton/DownloadButton';
import { mapInvoiceType } from '../invoice/invoiceHelpers';
import { deleteEntity } from '../../utlis/deleteEntity';
import '../../style/PageTable.css';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const PurchaseListTable = ({
  purchaseOrders,
  onEdit,
  onCopy,
  onDelete,
  onDownload,
  onRowClick,
  refreshOrders
}) => {

  const deletePO = async (id, e) => {
    await deleteEntity({
      entityType: 'purchase-orders',
      entityId: id,
      event: e,
      onDeleted: refreshOrders
    });
  };

  const renderRow = useCallback((po) => (
    <>
      <td>{po.id}</td>
      <td>{po.po_number}</td>
      <td>{formatDate(po.po_date)}</td>
      <td>{po.vendor_name}</td>
      <td>{po.vendor_email}<br />{po.vendor_phone}</td>
      {/* <td>{po.vendor_gst}</td> */}
      <td>₹{po.subtotal}</td>
      <td>₹{po.tax_amount}</td>
      <td><strong>₹{po.total_amount}</strong></td>
      <td>{po.status}</td>
      <td className="actions-cell">
        <div className="action-buttons">
          <EditButton onClick={(e) => { e.stopPropagation(); onEdit(po); }} />
          <CopyButton onClick={(e) => { e.stopPropagation(); onCopy(po); }} />
          <DeleteButton onClick={(e) => deletePO(po.id, e)} />
          <DownloadButton onClick={(e) => { e.stopPropagation(); onDownload(po); }} />
        </div>
      </td>
    </>
  ), [onEdit, onCopy, onDownload]);

  const columns = [
    { header: 'ID', style: { width: '50px' } },
    { header: 'PO Number', style: { width: '130px' } },
    { header: 'Date', style: { width: '90px' } },
    { header: 'Name', style: { width: '180px' } },
    { header: 'Contact Info', style: { maxWidth: '150px', width: '150px' } },
    // { header: 'GST', style: { width: '120px' } },
    { header: 'Subtotal', style: { width: '100px' } },
    { header: 'Tax Amt', style: { width: '100px' } },
    { header: 'Total Amt', style: { width: '110px' } },
    { header: 'Status', style: { width: '110px' } },
    { header: 'Actions', className: 'actions-header', style: { width: '100px' } }
  ];

  return (
    <Table
      columns={columns}
      data={purchaseOrders}
      renderRow={renderRow}
      className="page-table"
      onRowClick={onRowClick}
    />
  );
};

export default PurchaseListTable;